export default "__VITE_ASSET__04eccdc2__"